// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-form--container {
  padding-top: 20px;
}
.form-header-container {
  overflow-y: auto;
}
.bordered-button {
  border: 1px solid var(--primary-color) !important;
  min-width: 120px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  object-fit: contain;
}
.create-form--container .form-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.form-header-container .form-header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}
.form-header-container .btn-container {
  display: flex;
  gap: 15px;
  max-height: 35px;
  margin-top: 5px;
}
.alt-tag-with-img {
  padding: 0.5rem;
  border-radius: 4px;
  outline: none;
  border: 1px solid #d1cece;
  font-size: 16px;
}

.create-banneer-error {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  color: #f53232;
}
.jodit-container .jodit-placeholder {
  color: #808080; /* Placeholder color */
  font-size: 14px; /* Placeholder font size */
}

.blog-faq {
  margin-top: 10px;
}
.blog-faq .css-ir5tdx {
  margin-left: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/features/blog/createForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe,EAAE,0BAA0B;AAC7C;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".create-form--container {\n  padding-top: 20px;\n}\n.form-header-container {\n  overflow-y: auto;\n}\n.bordered-button {\n  border: 1px solid var(--primary-color) !important;\n  min-width: 120px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  object-fit: contain;\n}\n.create-form--container .form-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.form-header-container .form-header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n.form-header-container .btn-container {\n  display: flex;\n  gap: 15px;\n  max-height: 35px;\n  margin-top: 5px;\n}\n.alt-tag-with-img {\n  padding: 0.5rem;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid #d1cece;\n  font-size: 16px;\n}\n\n.create-banneer-error {\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 600;\n  color: #f53232;\n}\n.jodit-container .jodit-placeholder {\n  color: #808080; /* Placeholder color */\n  font-size: 14px; /* Placeholder font size */\n}\n\n.blog-faq {\n  margin-top: 10px;\n}\n.blog-faq .css-ir5tdx {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
